/**
 * Nhận báo cáo từ cấp dưới
 * pntoan 4.6.2024
 */
export default {
    Title: 'Nhận báo cáo cấp dưới',
    Detail: {
    }
  };
  